import { Divider, Group, Stack } from "@mantine/core";
import CommunityChooser from "./CommunityChooser";
import { useProfileStore } from "../../../../../stores/UserStore";

const CommunityManager = ({ profile, setProfile, changingProfile }) => {
  return (
    <Stack gap={"xs"}>
      {useProfileStore.getState().profile?.level === "admin" && (
        <CommunityChooser
          changingProfile={changingProfile}
          profile={profile}
          setProfile={setProfile}
          type={"resellers"}
        />
      )}

      <Group
        w={"100%"}
        wrap="nowrap"
        justify="space-between"
        align="start"
        mt={"sm"}
      >
        <CommunityChooser
          changingProfile={changingProfile}
          profile={profile}
          setProfile={setProfile}
          type={"teams"}
        />

        <Divider orientation="vertical" />

        <CommunityChooser
          changingProfile={changingProfile}
          profile={profile}
          setProfile={setProfile}
          type={"organizations"}
        />
      </Group>
    </Stack>
  );
};

export default CommunityManager;
